import { render, staticRenderFns } from "./SailRouteDetail.vue?vue&type=template&id=525c5314&scoped=true&"
import script from "./SailRouteDetail.vue?vue&type=script&lang=js&"
export * from "./SailRouteDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c5314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525c5314')) {
      api.createRecord('525c5314', component.options)
    } else {
      api.reload('525c5314', component.options)
    }
    module.hot.accept("./SailRouteDetail.vue?vue&type=template&id=525c5314&scoped=true&", function () {
      api.rerender('525c5314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/sail/SailRouteDetail.vue"
export default component.exports